
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 0C10.1 0 0 10.1 0 22.5S10.1 45 22.5 45 45 34.9 45 22.5 34.9 0 22.5 0z","fill":"#808f9f"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","d":"M27.5 9H16.6L9 16.6v10.8l7.6 7.6h10.8l7.6-7.6V16.5z"}}),_c('path',{attrs:{"d":"M25.1 27.6c0 1-.6 1.3-1.4.6l-7.5-6.1c-.3-.3-.3-.7 0-1l7.4-5.9c.8-.6 1.4-.3 1.4.7v11.7z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/object_forms/cabinet.svg